import React from 'react'

function DigitalMaketing() {
    return (
        <div className='text-center bg-blue-500 h-screen flex items-center justify-center'>
            <h1 className='text-2xl font-bold text-white'>Coming Soon</h1>
        </div>
    )
}

export default DigitalMaketing